const icon = require('vue-svgicon');
icon.register({
    'caret-right': {
        width: 512,
        height: 512,
        viewBox: '0 0 512 512',
        data: `<path pid="0" d="M161.454 498.036l-18.618-18.618L368.581 256 142.836 32.582l18.618-18.618L401.163 256z"/>`,
    },
});
